import { Button } from '@/components/ui/common/Button'

function ImportLayout({ onClick }: { onClick: () => void }) {
  return (
    <Button onClick={onClick} type="button">
      Importuj szablon
    </Button>
  )
}

export default ImportLayout
